export default "__VITE_ASSET__810db25c__"